import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Loader } from '../../../../shared/components/loader/loader';
import { ContentMapperService } from '../../../core/services/content-mapper-service';
import { ToastrService } from 'ngx-toastr';
import { NoDataComponent } from '../../../../shared/components/no-data/no-data.component';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ttd_endpoint } from '../../../data/api-endpoint/ttd-endpoint';

@Component({
  selector: 'app-content-pool-assets',
  imports: [CommonModule,Loader,NoDataComponent,FormsModule],
  templateUrl: './content-pool-assets.html',
  styleUrl: './content-pool-assets.scss'
})
export class ContentPoolAssets {
  searchIcon = 'assets/img/search.svg';


  loader:boolean = false;
  noData: boolean = false;
  toggleFilter:boolean = false;


  filterTokenId:string = ''
  
  filter: any = {
    page: 1,
    limit: 10,
    search: '',
    sortKey: '',
    sortValue: ''
  }
  contentPoolAsset:any[] = [];


  debounceTimeout: any

  constructor(private _contentMapper: ContentMapperService, private toastr: ToastrService,private _activatedRoute: ActivatedRoute){
  }

  ngOnInit(): void {
    this._activatedRoute.params.subscribe((params: any) => {
      this.filterTokenId = params.id;
      this.fetchContentPoolAssets()
    })

  }

  checkIsErrorMessageValid(error: any) {
    if(typeof error?.error?.message === 'string') {
      return error?.error?.message;
    }
    return 'An unknow error occured';
  }

  fetchContentPoolAssets() {
    this.loader = true;

    this._contentMapper.post(`${ttd_endpoint.search}/preview`, { filterToken: this.filterTokenId }).subscribe({
      next: (res: any) => {
        this.contentPoolAsset = res.results && res.results.preview || [];
        this.loader = false;
      }, error: (error: any) => {
        this.loader = false;
        this.toastr.error(this.checkIsErrorMessageValid(error));
      }, complete: () => {
        this.loader = false;
      }
    })

  }

  convertToCommaSeparated(data:string){
    if(!data) return '-';
    return data.split('|').join(', ');
  }


  onSearch(e: Event) {
    const value = (e.target as HTMLInputElement).value;
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      this.filter.search = value?.trim();
      this.filter.page = 1;
      this.fetchContentPoolAssets()
    }, 1000);
  }


  fetchUserDataByPage(data: { page: number }) {
    this.filter.page = data.page;
    this.fetchContentPoolAssets();
  }

}
